<template>
<div style="padding:10px;">
<van-cell-group :border=showBorder>
   <van-cell >
    <div style="text-align:center">
<van-image :src="imgcontent" v-show="showText"/>
</div>
   </van-cell>
</van-cell-group>
<van-cell-group v-show="showText" :border=showBorder>
   <van-cell >
   <div style="text-align:center">长按以上图片保存到相册</div>
   </van-cell>
</van-cell-group>
<van-loading  v-show="showLoad" color="#1989fa"/>
</div>
</template>
<script>
import Vue from 'vue';
import { Cell, CellGroup } from 'vant';
import { Loading } from 'vant';
import { Image as VanImage } from 'vant';

Vue.use(VanImage);
Vue.use(Loading);
Vue.use(Cell);
Vue.use(CellGroup);
export default {
		name: 'GetPrintCode',
		data() {
			return {
        qrcontent: 'CMD_CANCEL',
        showText:false,
        showLoad:false,
        showBorder:false,
        imgcontent:""
      }
		},methods:{

    scanCode(){

    this.showLoad=true;
 
    var that=this;
     // 传统写法
     this.$http.post('/shwjw/pie/getPrintQRCodeSmall?macid='+that.request("id"),[]).then(function(response){

        if(response.data.success){

           that.showLoad=false;
           that.imgcontent=response.data.img;
            that.showText=true;

        }else{

            that.showIcon="close";
            that.showContent="获取失败，请尝试重新获取";
            that.showText=true;
            that.showLoad=false;

        }

     }, function(response){
   
          that.showIcon="close";
          that.showContent="获取失败，请尝试重新获取";
          that.showText=true;
          that.showLoad=false;

    });},request(name) {
    var reg = new RegExp("(\\?|\&)" + name + "=([^&]*)(\&|$)", "i");
    var r = window.location.href.match(reg);
    if (r != null) return unescape(r[2]); return null;
    }

    },mounted(){
      
      this.scanCode();

    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/GetPrintCode.vue